<template>
  <el-card class="user-app">
    <div slot="header" class="header">
      <div class="app-name">
        <span>名称: </span> {{appInfo.app_name}}
      </div>
      <div class="app-created">
        <span>时间: </span> {{appInfo.created}}
      </div>
    </div>
    <div class="app-content">
      <div class="left">
        <span>状态: {{appInfo.is_active?'可用':'不可用'}}</span>
        <span>KEY: {{appInfo.app_key}}</span>
        <div style="margin-top: 1em">
          应用描述: {{appInfo.app_description}}
        </div>
      </div>
      <div class="right">
        <ul>
          <li>
            <i class="el-icon-info"></i>
            <router-link :to="{name: 'IdInfos', params: {app_key: appInfo.app_key, userApp: appInfo}}">身份证资源管理</router-link>
          </li>
          <li>
            <i class="el-icon-info"></i>
            <a href="javascript:void(0)" @click="$emit('onEdit')">修改参数</a>
          </li>
          <li>
            <i class="el-icon-info"></i>
            <el-popover
              placement="top"
              width="160"
              v-model="deleteConfirmVisible">
              <p>确定删除这个应用吗？</p>
              <div style="text-align: right; margin: 1em 0">
                <el-button size="mini" type="text" @click="deleteConfirmVisible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="onDeleteConfirmClicked" :loading="deleting">确定</el-button>
              </div>
              <a href="javascript:void(0)" slot="reference" @click="deleteConfirmVisible = true">删除应用</a>
            </el-popover>
          </li>
        </ul>
      </div>
    </div>
  </el-card>
</template>

<script>
  import EventBus from "@/EventBus"

  export default {
    name: "UserApp",
    props: ["appInfo"],
    data() {
      return {
        deleteConfirmVisible: false,
        deleting: false,
      }
    },
    created() {
      EventBus.$on("user_app_deleted", () => this.deleteConfirmVisible = false)
    },
    watch: {
      deleteConfirmVisible() {
        this.deleting = false;
      }
    },
    methods: {
      onDeleteConfirmClicked() {
        this.deleting = true;
        this.$emit("delete");
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../share/styles/user_app.styl"

  a
    text-decoration none

  .header
    display flex
    justify-content space-between

  .app-content
    display flex
    justify-content space-between
    min-height 7em
    width 100%

    & .left
      width 80%
      & span
        display inline-block
      & span + span
        margin-left 5em

    & .right
      text-align left
      & ul
        list-style-type none
        & li
          padding-bottom .8em
          & a
            color #00a8ec

  @media screen and (max-width: 500px)
    *
      font-size .98em

    .app-content
      display block
      & .left
        display inline-block
        width 100%
        & span + span
          margin-left 0

      & .right
        margin-top 1em
        display inline-block
        width 100%
        & ul
          & li
            padding-bottom .4em
</style>



// WEBPACK FOOTER //
// src/components/UserApp.vue